import { type AuthUser } from "../models/User";
import { CHAT_PRODUCT_ID } from "./accessControl";
import { normalizeSavedStickers } from "./savedStickerServices";

const normalizeAuthSavedStickers = ( stickers: AuthUser["savedStickers"] | any ): AuthUser["savedStickers"] => {
  if( !Array.isArray( stickers )) return [];
  if( stickers.some(( sticker ) => "fileMetadataId" in sticker )) return normalizeSavedStickers( stickers );
  return stickers;
};

export const normalizeAuthUser = ( user: AuthUser ): AuthUser => ({
  ...user,
  savedStickers: normalizeAuthSavedStickers( user.savedStickers ),
  access: user.access ?? {
    organizationId: user.organization?.id ?? "",
    productId: CHAT_PRODUCT_ID,
    entitlementStatus: "ACTIVE",
    userAccess: "ALLOWED",
    assignedRole: user.role,
  },
});
